var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { BreadCrumbSteps, PageLimit, theme, Icon, InfoDataBox, IconButton, Dialog, ExpandableText, } from "@sequentech/ui-essentials";
import { stringToHtml, EShowCastVoteLogsPolicy, formatVotingPortalDateTime, translateHtml, stringToText, } from "@sequentech/ui-core";
import { Box, TextField, Typography, Button, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { GET_CAST_VOTE } from "../queries/GetCastVote";
import { useQuery } from "@apollo/client/react";
import { faAngleLeft, faCircleQuestion, faCopy } from "@fortawesome/free-solid-svg-icons";
import { LIST_CAST_VOTE_MESSAGES } from "../queries/listCastVoteMessages";
import { useAppDispatch } from "../store/hooks";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { GET_ELECTION_EVENT } from "../queries/GetElectionEvent";
import { GET_ELECTIONS } from "../queries/GetElections";
import { setElectionEvent } from "../store/electionEvents/electionEventsSlice";
import Table from "@mui/material/Table";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
var StyledTitle = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 27px;\n    margin-top: 20px;\n    margin-bottom: 16px;\n"])));
var StyledError = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    margin-top: -12px;\n    color: ", ";\n"], ["\n    position: absolute;\n    margin-top: -12px;\n    color: ", ";\n"
    // Only one of the two ballot-id errors is shown at a time, so they can share the
    // id that the input's aria-describedby points at.
])), function (_a) {
    var theme = _a.theme;
    return theme.palette.red.main;
});
// Only one of the two ballot-id errors is shown at a time, so they can share the
// id that the input's aria-describedby points at.
var BALLOT_ID_ERROR_ID = "ballot-id-error";
var MessageSuccess = styled(Box)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    padding: 10px 22px;\n    color: ", ";\n    background-color: ", ";\n    gap: 8px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    align-items: center;\n    margin-right: auto;\n    margin-left: auto;\n    overflow-wrap: anywhere;\n"], ["\n    display: flex;\n    padding: 10px 22px;\n    color: ", ";\n    background-color: ", ";\n    gap: 8px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    align-items: center;\n    margin-right: auto;\n    margin-left: auto;\n    overflow-wrap: anywhere;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.green.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.green.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.green.dark;
});
var MessageFailed = styled(Box)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    padding: 10px 22px;\n    color: ", ";\n    background-color: ", ";\n    gap: 8px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    align-items: center;\n    margin-right: auto;\n    margin-left: auto;\n    overflow-wrap: anywhere;\n"], ["\n    display: flex;\n    padding: 10px 22px;\n    color: ", ";\n    background-color: ", ";\n    gap: 8px;\n    border-radius: 4px;\n    border: 1px solid ", ";\n    align-items: center;\n    margin-right: auto;\n    margin-left: auto;\n    overflow-wrap: anywhere;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.red.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.red.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.red.dark;
});
function isHex(str) {
    if (str.trim() === "") {
        return true;
    }
    if (str.length % 2 !== 0) {
        return false;
    }
    var regex = /^[0-9a-fA-F]+$/;
    return regex.test(str);
}
var CustomTabPanel = function (_a) {
    var children = _a.children, index = _a.index, value = _a.value, className = _a.className;
    return (_jsx("div", { className: className, role: "tabpanel", hidden: value !== index, id: "simple-tabpanel-".concat(index), "aria-labelledby": "simple-tab-".concat(index), children: value === index && _jsx(Box, { className: "ballot-locator-panel-content", children: children }) }));
};
var BallotLocator = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var location = useLocation();
    var _b = useParams(), tenantId = _b.tenantId, eventId = _b.eventId, electionId = _b.electionId;
    var dispatch = useAppDispatch();
    var allowSendRequest = useRef(true);
    var _c = React.useState(0), value = _c[0], setValue = _c[1];
    var _d = useState(""), inputBallotId = _d[0], setInputBallotId = _d[1];
    var _e = useState([]), rows = _e[0], setRows = _e[1];
    var _f = useState(0), total = _f[0], setTotal = _f[1];
    var _g = useState(false), ballotIdNotFoundErr = _g[0], setBallotIdNotFoundErr = _g[1];
    var _h = useState(false), somethingWentWrongErr = _h[0], setSomethingWentWrongErr = _h[1];
    var validatedBallotId = isHex(inputBallotId !== null && inputBallotId !== void 0 ? inputBallotId : "");
    var _j = useState(false), showCVLogsPolicy = _j[0], setShowCVLogsPolicy = _j[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _k = React.useState(0), page = _k[0], setPage = _k[1];
    var _l = React.useState(5), rowsPerPage = _l[0], setRowsPerPage = _l[1];
    var lastCVRequestTimestamp = useRef(undefined); // Timestamp of last LIST_CAST_VOTE_MESSAGES request
    var dataElectionEvent = useQuery(GET_ELECTION_EVENT, {
        variables: {
            electionEventId: eventId,
            tenantId: tenantId,
        },
        skip: globalSettings.DISABLE_AUTH, // Skip query if in demo mode
    }).data;
    useEffect(function () {
        var electionEvent = dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event[0];
        if (electionEvent) {
            dispatch(setElectionEvent(electionEvent));
        }
    }, [dataElectionEvent, dispatch]);
    var refetch = useQuery(LIST_CAST_VOTE_MESSAGES, {
        variables: {
            tenantId: tenantId,
            electionEventId: eventId,
            electionId: electionId,
            ballotId: inputBallotId,
        },
        skip: true,
    }).refetch;
    var fetchTimeout = useRef(undefined);
    var requestCVMsgs = function (headerName, newOrder) { return __awaiter(void 0, void 0, void 0, function () {
        function tryFetchMessages() {
            return __awaiter(this, void 0, void 0, function () {
                var limit, offset, data, e_1;
                var _a;
                var _b, _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            _f.trys.push([0, 2, , 3]);
                            limit = rowsPerPage;
                            offset = page * rowsPerPage;
                            return [4 /*yield*/, refetch({
                                    ballotId: inputBallotId,
                                    orderBy: (_a = {}, _a[headerName !== null && headerName !== void 0 ? headerName : "id"] = newOrder !== null && newOrder !== void 0 ? newOrder : "desc", _a),
                                    limit: limit,
                                    offset: offset,
                                })];
                        case 1:
                            data = (_f.sent()).data;
                            console.log(data);
                            if (data === null || data === void 0 ? void 0 : data.list_cast_vote_messages) {
                                setRows(((_c = (_b = data === null || data === void 0 ? void 0 : data.list_cast_vote_messages) === null || _b === void 0 ? void 0 : _b.list) !== null && _c !== void 0 ? _c : []));
                                setTotal((_d = data === null || data === void 0 ? void 0 : data.list_cast_vote_messages) === null || _d === void 0 ? void 0 : _d.total);
                                setBallotIdNotFoundErr(inputBallotId.length > 0 && ((_e = data === null || data === void 0 ? void 0 : data.list_cast_vote_messages) === null || _e === void 0 ? void 0 : _e.list.length) === 0);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _f.sent();
                            setSomethingWentWrongErr(true);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        var duration, tooQuick;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    duration = lastCVRequestTimestamp.current
                        ? Date.now() - lastCVRequestTimestamp.current
                        : undefined;
                    tooQuick = duration ? duration < 500 : false;
                    lastCVRequestTimestamp.current = Date.now();
                    if (tooQuick) {
                        // Start interval
                        // if timeout is already running, destroy it and create a new one.
                        clearTimeout(fetchTimeout.current);
                        fetchTimeout.current = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, tryFetchMessages()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1000);
                    }
                    if (globalSettings.DISABLE_AUTH || tooQuick || !validatedBallotId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, tryFetchMessages()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onClickHeader = function (headerName, newOrder) {
        requestCVMsgs(headerName, newOrder);
    };
    useEffect(function () {
        var _a, _b;
        if (validatedBallotId) {
            setBallotIdNotFoundErr(false);
        }
        var showLogs = (_b = (_a = dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event[0]) === null || _a === void 0 ? void 0 : _a.presentation) === null || _b === void 0 ? void 0 : _b.show_cast_vote_logs;
        setShowCVLogsPolicy(showLogs === EShowCastVoteLogsPolicy.SHOW_LOGS_TAB);
        // the length must be an even number of characters
        if (showLogs && allowSendRequest.current) {
            allowSendRequest.current = false;
            requestCVMsgs();
        }
    }, [inputBallotId, dataElectionEvent, page, rowsPerPage]);
    var handleChangePage = function (event, newPage) {
        allowSendRequest.current = true;
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        allowSendRequest.current = true;
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    var a11yProps = function (index) {
        return {
            "id": "simple-tab-".concat(index),
            "aria-controls": "simple-tabpanel-".concat(index),
        };
    };
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var captureEnter = function (event) {
        allowSendRequest.current = true;
    };
    return (_jsxs(PageLimit, { className: "ballot-locator-screen screen", maxWidth: "lg", sx: { marginTop: "48px", width: "100%" }, children: [_jsx(Box, { className: "ballot-locator-tabs-container", sx: { borderBottom: 1, borderColor: "divider" }, children: _jsxs(Tabs, { className: "ballot-locator-tabs", variant: "scrollable", allowScrollButtonsMobile: true, scrollButtons: "auto", indicatorColor: "primary", textColor: "inherit", sx: { fontFamily: "Roboto" }, "aria-label": t("a11y.ballotLocatorTabs"), value: value, onChange: handleChange, children: [_jsx(Tab, __assign({ className: "ballot-lookup-tab", label: t("ballotLocator.tabs.ballotLocator") }, a11yProps(0))), showCVLogsPolicy && (_jsx(Tab, __assign({ className: "cast-vote-logs-tab", label: t("ballotLocator.tabs.logs") }, a11yProps(1))))] }) }), _jsxs(Box, { className: "ballot-locator-panels", sx: { p: 3 }, children: [_jsx(CustomTabPanel, { className: "ballot-lookup-panel", value: value, index: 0, children: _jsx(BallotLocatorLogic, {}) }), _jsxs(CustomTabPanel, { className: "cast-vote-logs-panel", value: value, index: 1, children: [_jsx(Box, { className: "cast-vote-logs-filter", marginTop: "48px", children: _jsx(BallotIdInput, { inputBallotId: inputBallotId, setInputBallotId: setInputBallotId, validatedBallotId: validatedBallotId, ballotIdNotFoundErr: ballotIdNotFoundErr, captureEnter: captureEnter, placeholderLabel: "ballotLocator.filterByBallotId" }) }), _jsx(LogsTable, { rows: rows, total: total, onOrderBy: onClickHeader, rowsPerPage: rowsPerPage, handleChangeRowsPerPage: handleChangeRowsPerPage, page: page, handleChangePage: handleChangePage, somethingWentWrongErr: somethingWentWrongErr, formatDateTime: function (timestamp) {
                                    return formatVotingPortalDateTime(timestamp, dataElectionEvent === null || dataElectionEvent === void 0 ? void 0 : dataElectionEvent.sequent_backend_election_event[0], i18n.resolvedLanguage || i18n.language);
                                } })] }), _jsx(Box, { className: "ballot-locator-actions", sx: {
                            order: { xs: 1, md: 2 },
                            marginTop: "20px",
                            width: "fit-content",
                        }, children: _jsxs(Button, { component: Link, to: "/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search), variant: "secondary", className: "secondary back-button", children: [_jsx(Icon, { className: "back-button-icon", icon: faAngleLeft, size: "sm" }), _jsx(Box, { className: "back-button-label", children: t("votingScreen.backButton") })] }) })] })] }));
};
var MessageCell = function (_a) {
    var message = _a.message, initialLength = _a.initialLength;
    var t = useTranslation().t;
    var formatJson = function (json) {
        try {
            return JSON.stringify(JSON.parse(json), null, 2);
        }
        catch (_a) {
            return json;
        }
    };
    if (!message) {
        return _jsx("div", { className: "cast-vote-log-empty-message", children: "-" });
    }
    var formattedMessage = formatJson(message);
    return (_jsxs(Box, { className: "cast-vote-log-message", sx: { position: "relative", width: "100%" }, children: [_jsx(IconButton, { buttonClassName: "cast-vote-log-copy-button", icon: faCopy, size: "xs", onClick: function () { return navigator.clipboard.writeText(formattedMessage); }, ariaLabel: t("a11y.copyToClipboard", {
                    label: t("ballotLocator.column.message"),
                }), sx: {
                    "position": "absolute",
                    "top": "4px",
                    "left": "4px",
                    "zIndex": 1,
                    "backgroundColor": "rgba(255, 255, 255, 0.8)",
                    "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                    },
                    "minWidth": "20px",
                    "minHeight": "20px",
                    "padding": "2px",
                } }), _jsx(Box, { className: "cast-vote-log-message-content", sx: {
                    "paddingLeft": "28px",
                    "& > div > div:last-child": {
                        justifyContent: "flex-start !important",
                    },
                }, children: _jsx(ExpandableText, { text: formattedMessage, initialLength: initialLength, showMoreLabel: t("common.showMore"), showLessLabel: t("common.showLess"), preformatted: true }) })] }));
};
var LogsTable = function (_a) {
    var rows = _a.rows, total = _a.total, onOrderBy = _a.onOrderBy, rowsPerPage = _a.rowsPerPage, handleChangeRowsPerPage = _a.handleChangeRowsPerPage, page = _a.page, handleChangePage = _a.handleChangePage, _b = _a.somethingWentWrongErr, somethingWentWrongErr = _b === void 0 ? false : _b, formatDateTime = _a.formatDateTime;
    var t = useTranslation().t;
    var _c = useState(""), orderBy = _c[0], setOrderBy = _c[1];
    var _d = useState("desc"), order = _d[0], setOrder = _d[1];
    var _e = useState(window.innerWidth), windowWidth = _e[0], setWindowWidth = _e[1];
    useEffect(function () {
        var handleResize = function () { return setWindowWidth(window.innerWidth); };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, []);
    // Calculate initialLength: 20 at 1200px+, scale down faster (quadratic) below 1200px
    var ratio = windowWidth / 1200;
    var initialLength = windowWidth >= 1200 ? 20 : Math.max(3, Math.floor(ratio * ratio * ratio * 20));
    var onClickHeader = function (headerName) {
        setOrderBy(headerName);
        var newOrder = order === "desc" ? "asc" : "desc";
        setOrder(newOrder);
        onOrderBy === null || onOrderBy === void 0 ? void 0 : onOrderBy(headerName, newOrder);
    };
    return (_jsxs(_Fragment, { children: [_jsx(StyledTitle, { className: "cast-vote-logs-title", variant: "h5", component: "h2", children: t("ballotLocator.totalBallots", { total: total }) }), _jsx(TableContainer, { className: "cast-vote-logs-table-container", component: Paper, sx: { overflowX: "auto", width: "100%" }, children: _jsxs(Table, { className: "cast-vote-logs-table", sx: {
                        "tableLayout": "auto",
                        "& .MuiTableCell-root": {
                            border: "1px solid #e0e0e0",
                        },
                    }, "aria-label": t("a11y.ballotsTable"), children: [_jsx(TableHead, { className: "cast-vote-logs-table-head", children: _jsxs(TableRow, { className: "cast-vote-logs-header-row", children: [_jsx(TableCell, { className: "cast-vote-logs-username-header", align: "center", sortDirection: orderBy === "username" ? order : false, sx: { fontWeight: "bold", padding: "2px 4px" }, children: _jsx(TableSortLabel, { className: "cast-vote-logs-sort-button", active: orderBy === "username", direction: orderBy === "username" ? order : "asc", onClick: function () { return onClickHeader("username"); }, sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                            }, children: t("ballotLocator.column.username") }) }), _jsx(TableCell, { className: "cast-vote-logs-ballot-id-header", align: "center", sortDirection: orderBy === "ballot_id" ? order : false, sx: { fontWeight: "bold", padding: "2px 4px" }, children: _jsx(TableSortLabel, { className: "cast-vote-logs-sort-button", active: orderBy === "ballot_id", direction: orderBy === "ballot_id" ? order : "asc", onClick: function () { return onClickHeader("ballot_id"); }, sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                            }, children: t("ballotLocator.column.ballot_id") }) }), _jsx(TableCell, { className: "cast-vote-logs-kind-header", align: "center", sortDirection: orderBy === "statement_kind" ? order : false, sx: { fontWeight: "bold", padding: "2px 4px" }, children: _jsx(TableSortLabel, { className: "cast-vote-logs-sort-button", active: orderBy === "statement_kind", direction: orderBy === "statement_kind" ? order : "asc", onClick: function () { return onClickHeader("statement_kind"); }, sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                            }, children: t("ballotLocator.column.statement_kind") }) }), _jsx(TableCell, { className: "cast-vote-logs-timestamp-header", align: "center", sortDirection: orderBy === "statement_timestamp" ? order : false, sx: { fontWeight: "bold", padding: "2px 4px" }, children: _jsx(TableSortLabel, { className: "cast-vote-logs-sort-button", active: orderBy === "statement_timestamp", direction: orderBy === "statement_timestamp" ? order : "asc", onClick: function () { return onClickHeader("statement_timestamp"); }, sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                            }, children: t("ballotLocator.column.statement_timestamp") }) }), _jsx(TableCell, { className: "cast-vote-logs-message-header", align: "center", sx: { fontWeight: "bold", padding: "2px 4px" }, children: _jsx(Box, { className: "cast-vote-logs-message-heading", sx: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                            }, children: t("ballotLocator.column.message") }) })] }) }), _jsx(TableBody, { className: "cast-vote-logs-table-body", children: rows.map(function (row, index) {
                                var _a;
                                return (_jsxs(TableRow, { className: "cast-vote-logs-row", children: [_jsx(TableCell, { className: "cast-vote-logs-username-cell", align: "center", sx: {
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                padding: "2px 4px",
                                            }, children: (_a = row.username) !== null && _a !== void 0 ? _a : "-" }), _jsx(TableCell, { className: "cast-vote-logs-ballot-id-cell", align: "center", sx: {
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                padding: "2px 4px",
                                            }, children: initialLength < 10 ? (_jsx(ExpandableText, { text: row.ballot_id, initialLength: initialLength, showMoreLabel: t("common.showMore"), showLessLabel: t("common.showLess"), preformatted: true })) : (row.ballot_id) }), _jsx(TableCell, { className: "cast-vote-logs-kind-cell", align: "center", sx: {
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                padding: "2px 4px",
                                            }, children: row.statement_kind }), _jsx(TableCell, { className: "cast-vote-logs-timestamp-cell", align: "center", sx: {
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                padding: "2px 4px",
                                            }, children: formatDateTime(row.statement_timestamp * 1000) }), _jsx(TableCell, { className: "cast-vote-logs-message-cell", align: "justify", sx: {
                                                wordBreak: "break-all",
                                                whiteSpace: "normal",
                                                padding: "2px 4px",
                                            }, children: _jsx(MessageCell, { message: row.message, initialLength: initialLength }) })] }, index));
                            }) })] }) }), _jsx(TablePagination, { className: "cast-vote-logs-pagination", rowsPerPageOptions: [5, 10, 25, 50], component: "div", count: total, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage }), somethingWentWrongErr && (_jsx(StyledError, { className: "cast-vote-logs-error", component: "div", children: stringToHtml(t("errors.page.somethingWrong")) }))] }));
};
var BallotIdInput = function (_a) {
    var inputBallotId = _a.inputBallotId, setInputBallotId = _a.setInputBallotId, validatedBallotId = _a.validatedBallotId, _b = _a.ballotIdNotFoundErr, ballotIdNotFoundErr = _b === void 0 ? false : _b, captureEnter = _a.captureEnter, placeholderLabel = _a.placeholderLabel;
    var t = useTranslation().t;
    var hasBallotIdError = !validatedBallotId || ballotIdNotFoundErr;
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { className: "ballot-id-field", onChange: function (event) {
                    setInputBallotId(event.target.value);
                }, value: inputBallotId, label: t("a11y.ballotIdLabel"), placeholder: stringToText(t(placeholderLabel)), onKeyDown: captureEnter, error: hasBallotIdError, slotProps: {
                    htmlInput: {
                        "className": "ballot-id-input",
                        "aria-describedby": hasBallotIdError ? BALLOT_ID_ERROR_ID : undefined,
                    },
                    inputLabel: { shrink: true },
                } }), _jsx(StyledError, { className: "ballot-id-error", id: BALLOT_ID_ERROR_ID, role: "alert", component: "div", children: !validatedBallotId
                    ? stringToHtml(t("ballotLocator.wrongFormatBallotId"))
                    : ballotIdNotFoundErr
                        ? stringToHtml(t("ballotLocator.ballotIdNotFoundAtFilter"))
                        : "" })] }));
};
var BallotLocatorLogic = function () {
    var _a, _b, _c;
    var _d = useParams(), tenantId = _d.tenantId, eventId = _d.eventId, electionId = _d.electionId, ballotId = _d.ballotId;
    var _e = useState(false), openTitleHelp = _e[0], setOpenTitleHelp = _e[1];
    var navigate = useNavigate();
    var location = useLocation();
    var t = useTranslation().t;
    var _f = useState(""), inputBallotId = _f[0], setInputBallotId = _f[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var hasBallotId = !!ballotId;
    var _g = useQuery(GET_ELECTIONS, {
        variables: {
            electionIds: electionId ? [electionId] : [],
        },
        skip: globalSettings.DISABLE_AUTH || !electionId,
    }), dataElections = _g.data, loadingElections = _g.loading;
    var election = dataElections === null || dataElections === void 0 ? void 0 : dataElections.sequent_backend_election.find(function (item) { return item.id === electionId; });
    var telephoneVotingEnabled = ((_a = election === null || election === void 0 ? void 0 : election.voting_channels) === null || _a === void 0 ? void 0 : _a.telephone) === true;
    var normalizedBallotId = (_b = ballotId === null || ballotId === void 0 ? void 0 : ballotId.toLowerCase()) !== null && _b !== void 0 ? _b : "";
    var ballotIdPattern = /^[0-9a-f]+$/.test(normalizedBallotId)
        ? telephoneVotingEnabled && normalizedBallotId.length === 4
            ? "".concat(normalizedBallotId, "%")
            : normalizedBallotId
        : "";
    var dispatch = useAppDispatch();
    var _h = useQuery(GET_CAST_VOTE, {
        variables: {
            tenantId: tenantId,
            electionEventId: eventId,
            electionId: electionId,
            ballotIdPattern: ballotIdPattern,
        },
        skip: globalSettings.DISABLE_AUTH || !hasBallotId || loadingElections,
    }), data = _h.data, loading = _h.loading;
    var validatedBallotId = isHex(inputBallotId !== null && inputBallotId !== void 0 ? inputBallotId : "");
    var matchingBallots = (_c = data === null || data === void 0 ? void 0 : data["sequent_backend_cast_vote"]) !== null && _c !== void 0 ? _c : [];
    var ambiguousBallotId = matchingBallots.length > 1;
    var ballotContent = matchingBallots.length === 1 ? matchingBallots[0].content : null;
    var lookupLoading = loadingElections || loading;
    var locate = function (withBallotId) {
        if (withBallotId === void 0) { withBallotId = false; }
        var id = withBallotId ? inputBallotId : "";
        setInputBallotId("");
        navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/ballot-locator/").concat(id).concat(location.search));
    };
    var captureEnter = function (event) {
        if ("Enter" === event.key) {
            locate(true);
        }
    };
    return (_jsxs(Stack, { className: "ballot-locator-content ".concat(hasBallotId ? "ballot-locator-result" : "ballot-locator-search"), children: [_jsx(Box, { className: "stepper-box", marginTop: "48px", children: _jsx(BreadCrumbSteps, { labels: ["ballotLocator.steps.lookup", "ballotLocator.steps.result"], selected: hasBallotId ? 1 : 0 }) }), _jsx(Box, { className: "ballot-locator-header", sx: {
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }, children: _jsxs(Box, { className: "ballot-locator-heading", sx: {
                        order: { xs: 2, md: 1 },
                    }, children: [_jsxs(StyledTitle, { className: "screen-title", variant: "h1", children: [!hasBallotId ? (_jsx(Box, { className: "screen-title-text", children: t("ballotLocator.title") })) : (_jsx(Box, { className: "screen-title-text", children: t("ballotLocator.titleResult") })), _jsx(IconButton, { buttonClassName: "screen-help-button", icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenTitleHelp(true); }, ariaLabel: t("a11y.helpAbout", {
                                        topic: t("ballotLocator.titleHelpDialog.title"),
                                    }) }), _jsx(Dialog, { className: "screen-help-dialog ballot-locator-help-dialog", handleClose: function () { return setOpenTitleHelp(false); }, open: openTitleHelp, title: t("ballotLocator.titleHelpDialog.title"), ok: t("ballotLocator.titleHelpDialog.ok"), variant: "info", children: stringToHtml(t("ballotLocator.titleHelpDialog.content")) })] }), _jsx(Typography, { className: "screen-description", variant: "body1", component: "div", sx: { color: theme.palette.customGrey.contrastText }, children: stringToHtml(t("ballotLocator.description")) })] }) }), _jsx(Box, { className: "ballot-lookup-status", role: "status", children: hasBallotId && !lookupLoading ? (ambiguousBallotId ? (_jsx(MessageFailed, { className: "ballot-locator-failure", children: translateHtml(t, "ballotLocator.ambiguous", { ballotId: ballotId }) })) : ballotContent ? (_jsx(MessageSuccess, { className: "ballot-locator-success", children: translateHtml(t, "ballotLocator.found", { ballotId: ballotId }) })) : (_jsx(MessageFailed, { className: "ballot-locator-failure", children: translateHtml(t, "ballotLocator.notFound", { ballotId: ballotId }) }))) : null }), !hasBallotId && (_jsx(BallotIdInput, { inputBallotId: inputBallotId, setInputBallotId: setInputBallotId, validatedBallotId: validatedBallotId, captureEnter: captureEnter, placeholderLabel: "ballotLocator.description" })), hasBallotId && ballotContent && (_jsxs(_Fragment, { children: [_jsx(Typography, { className: "ballot-content-description", component: "div", children: stringToHtml(t("ballotLocator.contentDesc")) }), _jsx(InfoDataBox, { className: "ballot-content", children: ballotContent })] })), !hasBallotId ? (_jsx(Button, { sx: { marginTop: "10px", width: "fit-content" }, disabled: !validatedBallotId || inputBallotId.trim() === "", className: "normal locate-ballot-button", onClick: function () { return locate(true); }, children: _jsx("span", { className: "locate-ballot-label", children: t("ballotLocator.locate") }) })) : (_jsx(_Fragment, { children: _jsx(Button, { sx: { marginTop: "10px", width: "fit-content" }, className: "normal locate-again-button", onClick: function () { return locate(); }, children: _jsx("span", { className: "locate-ballot-again-label", children: t("ballotLocator.locateAgain") }) }) }))] }));
};
export default BallotLocator;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
